module.exports = __webpack_public_path__ + "img/中评.8b267dae.png";